{
  "about": {
    "paragraph": "Мы стремимся решать задачи закона AGEC и информировать наших клиентов о происхождении и экологических качествах наших продуктов.",
    "title": "О нас"
  },
  "lastUpdate": "Дата последнего обновления: ",
  "loading": {
    "dataPending": "в настоящее время собирает эту информацию",
    "pendingLocation": "Ожидание местоположения"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Производство одежды",
    "FOOTWEAR_FINISHING": "Отделка обуви",
    "FOOTWEAR_STITCHING": "Пошив обуви",
    "FOOTWEAR_ASSEMBLING": "Сборка обуви",
    "FABRIC_WEAVING_OR_KNITTING": "Ткачество или вязание тканей",
    "FABRIC_DYEING_PRINTING": "Крашение или печать тканей",
    "YARN_PROVIDER": "Поставщик пряжи",
    "YARN_DYEING_PRINTING": "Крашение или печать пряжи",
    "LEATHER_TANNING": "Дубление кожи",
    "LEATHER_DYEING_PRINTING": "Крашение или печать кожи",
    "ACCESSORY_PROVIDER": "Поставщик аксессуаров",
    "YARN_MATERIAL_PRODUCTION": "Производство материалов пряжи",
    "FABRIC_SPINNING": "Прядение тканей",
    "FABRIC_MATERIAL_PRODUCTION": "Производство тканевых материалов",
    "LEATHER_MATERIAL_PRODUCTION": "Производство кожаных материалов",
    "LEATHER_FARM": "Ферма па развядзенні",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Поставщик сырья для аксессуаров",
    "COATING": "Пакрыццё"
  },
  "other": {
    "microplastics_bold": "выделяет микропластик ",
    "paragraph1": "Этот продукт содержит ",
    "paragraph1_100": "Этот продукт содержит 100% переработанных материалов.",
    "paragraph2_1": "Этот продукт ",
    "paragraph2_2": "  в окружающую среду при стирке: ",
    "paragraph2_3": "по массе продукта состоит из синтетических волокон.",
    "paragraph3": "Информация о возможном наличии опасных веществ в применении: ",
    "recycled_matertials_bold": "не менее {{percent}}% переработанных материалов.",
    "recycled_matertials_bold_50": "более 50% ",
    "title": "Другие экологические качества и особенности"
  },
  "packaging": {
    "recyclable": "Перерабатываемый: Упаковка подлежит переработке.",
    "recycled": "Переработанные материалы: Упаковка содержит не менее {{percent}}% переработанных материалов.",
    "recycled_100": "Переработанные материалы: Упаковка содержит 100% переработанных материалов.",
    "title": "Экологические качества и особенности упаковки"
  },
  "title": "Лист продукта об экологических качествах или характеристиках",
  "traceability": {
    "paragraph": "Это относится к происхождению вашего продукта на первых трех этапах производства, от его создания до ткачества и крашения основного материала.",
    "title": "Прослеживаемость продукта"
  },
  "ecoScore": {
    "title": "ЭкоСчет"
  }
}
